import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const OpenInIcon = createIcon({
    viewBox: '0 0 16 15',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.961 0h5.82v5.82h-1.68V2.86l-6.16 6.16-1.18-1.18 6.16-6.16h-2.96V0zm4.14 13.32V8.5h1.68v4.82c0 .453-.166.847-.5 1.18-.333.333-.726.5-1.18.5H2.461c-.466 0-.863-.167-1.19-.5a1.63 1.63 0 0 1-.49-1.18V1.68c0-.453.164-.847.49-1.18.327-.333.724-.5 1.19-.5h4.82v1.68h-4.82v11.64h11.64z'
        />
    ),
})

OpenInIcon.displayName = 'OpenInIcon'
